import ajax from '@common/ajax/promise/ajax'
import ClientCookie from '@common/Cookie/ClientCookie'
import { EHttpStatusCode } from '@common/http/definitions'

import { is } from '@common/is/is'

import { EAuthRoute } from './definitions'

const COOKIE_NAME = 'corp:stoc'

const stoc = {
  set: (value: string): void => {
    ClientCookie.set(ClientCookie.make({
      name: COOKIE_NAME,
      value,
      daysToLive: 1,
      sameSite: 'Lax'
    }))
  },

  get: (): string | undefined => {
    return ClientCookie.get(COOKIE_NAME)
  },

  has: (): boolean => {
    const hasCookie = is.string(ClientCookie.get(COOKIE_NAME))

    return hasCookie
  },

  isValid: async (): Promise<boolean> =>  {
    const res = await ajax(`${ EAuthRoute.Validate }?stoc=${ stoc.get() }`, {
      method: 'GET'
    })

    const isValid = res?.status === EHttpStatusCode.Ok

    return isValid
  },

  delete: (): void => {
    ClientCookie.delete(COOKIE_NAME)
  }
} as const

export default stoc
